const config = {
  version: '2.7.4',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts